<template>
    <button type="button" class="my-home-back" :disabled="disabled" @click="$emit('back')">
        <svg viewBox="0 0 10 16" aria-hidden="true"><path d="M0 7.79423L9.75 0V15.5885Z" fill="currentColor" /></svg>
        {{ $t('specials.backButton') }}
    </button>
    <header class="my-home-title">
        <span class="my-home-title__line" aria-hidden="true"><svg viewBox="0 0 17 11"><path d="M5.5 .5H.5L11.5 10.5H16.5Z" fill="#cacaca" stroke="#cacaca" /></svg></span>
        <span>{{ title }}</span>
        <span class="my-home-title__line my-home-title__line--right" aria-hidden="true"><svg viewBox="0 0 17 11"><path d="M5.5 .5H.5L11.5 10.5H16.5Z" fill="#cacaca" stroke="#cacaca" /></svg></span>
    </header>
</template>

<script>
export default {
    name: 'MyHomePageHeader',
    props: { title: { type: String, required: true }, disabled: Boolean },
    emits: ['back']
}
</script>

<style scoped>
.my-home-page .my-home-back { display: flex; align-items: center; align-self: flex-start; flex-shrink: 0; gap: 6px; height: 18px; margin: 0 0 20px -4px; padding: 0; border: 0; background: transparent; color: var(--home-green); font-family: inherit; font-size: 15px; line-height: 16px; cursor: pointer; }
.my-home-back:disabled { cursor: default; opacity: .5; }
.my-home-back svg { display: block; flex: 0 0 10px; width: 10px; height: 16px; }
.my-home-title { display: flex; flex-shrink: 0; align-items: center; justify-content: center; gap: 26px; height: 14px; margin: 0 -12px 18px; color: var(--home-green); font-size: 13px; line-height: 14px; text-align: center; }
.my-home-title__line { position: relative; flex: 1; min-width: 17px; height: 11px; }
.my-home-title__line::before { content: ''; position: absolute; top: 0; left: 0; right: 16px; height: 1px; background: #cacaca; }
.my-home-title__line svg { position: absolute; right: 0; top: 0; width: 17px; height: 11px; }
.my-home-title__line--right { transform: rotate(180deg); }
@media (max-width: 340px) { .my-home-title { gap: 12px; } }
</style>
